import camelCase from 'lodash/camelCase'
const requireModule = require.context('.', true, /\.js$/)
const api = {}

requireModule.keys().forEach(fileName => {

  if (fileName.match('index.js') || fileName.match('base-http.js')) {
    return
  }
  
  const module = requireModule(fileName).default

  fileName = fileName.replace(/(\.\/|\.js)/g, '')
  
  api[camelCase(fileName)]= module
})

export default api